import { makeStyles } from "@material-ui/core/styles";
import { colors } from "~/utils/colors";

const { background, brand } = colors;

export default makeStyles((theme) => ({
	"@keyframes slideUp": {
		from: {
			transform: "translateY(100%)",
			opacity: 0,
		},
		to: {
			transform: "translateY(0)",
			opacity: 1,
		},
	},

	"@keyframes checkSlideUp": {
		from: {
			transform: "translateY(60px) scale(0.8)",
			opacity: 0,
		},
		to: {
			transform: "translateY(0) scale(1)",
			opacity: 1,
		},
	},

	container: {
		position: "fixed",
		bottom: 0,
		left: 0,
		right: 0,
		width: "100%",
		maxWidth: 480,
		minHeight: 300, // Altura fixa para status normais
		margin: "0 auto",
		display: "flex",
		flexDirection: "column",
		padding: 20,
		borderTopLeftRadius: 30,
		borderTopRightRadius: 30,
		boxShadow: "0px -4px 12px rgba(0, 0, 0, 0.2)",
		backgroundColor: background?.default || "#FFFFFF",
		animation: "$slideUp 0.3s ease-out",
		zIndex: 1300,
	},

	containerSuccess: {
		position: "fixed",
		bottom: 0,
		left: 0,
		right: 0,
		width: "100%",
		maxWidth: 480,
		margin: "0 auto",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center", // Centraliza o conteúdo quando menor que 300px
		padding: 20,
		borderTopLeftRadius: 30,
		borderTopRightRadius: 30,
		boxShadow: "0px -4px 12px rgba(0, 0, 0, 0.2)",
		backgroundColor: background?.default || "#FFFFFF",
		animation: "$slideUp 0.3s ease-out",
		zIndex: 1300,
	},

	closeButton: {
		position: "absolute",
		top: 16,
		right: 16,
		cursor: "pointer",
		zIndex: 1,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: 32,
		height: 32,
		borderRadius: "50%",
		backgroundColor: "rgba(0, 0, 0, 0.05)",
		transition: "background-color 0.2s ease",
		"&:hover": {
			backgroundColor: "rgba(0, 0, 0, 0.1)",
		},
	},

	containerChildren: {
		padding: "0 20px 20px 20px",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		flex: 1, // Permite ocupar todo o espaço disponível no containerSuccess
	},

	button: {
		backgroundColor: "#672E37",
		color: "#fff",
		border: "none",
		width: "100%",
		padding: "8px",
		borderRadius: "100px",
		textTransform: "none",
		fontWeight: "bold",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		"&:hover": {
			backgroundColor: "#672E37",
			color: "white",
		},
		"&:disabled": {
			backgroundColor: "#f5f5f5",
			color: "#999999",
			border: "1px solid #cccccc",
			cursor: "not-allowed",
			opacity: 0.7,
		},
	},

	// DialogWhatsAppAuth styles
	dialogContainer: {
		maxWidth: 480,
		margin: "0 auto",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		flex: 1, // Ocupa espaço disponível e permite centralização
	},

	dialogHeader: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		textAlign: "center",
		justifyContent: "center",
		gap: 0,
		flex: 1, // Permite centralização vertical no espaço disponível
	},

	dialogHeaderSuccess: {
		transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
	},

	successContentContainer: {
		maxHeight: "300px",
		opacity: 1,
		transform: "translateY(0)",
		transition: "max-height 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.3s ease-in-out, transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
		overflow: "hidden",
		paddingTop: "8px",
	},

	successContentContainerHidden: {
		maxHeight: "0px",
		opacity: 0,
		transform: "translateY(-12px)",
		transition: "max-height 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.1s ease-out, transform 0.1s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
		overflow: "hidden",
		paddingTop: "0px",
	},

	iconContainer: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		marginBottom: 20,
	},

	successCheckContainer: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		marginBottom: 20,
		animation: "$checkSlideUp 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.1s both",
	},

	loadingContainer: {
		marginBottom: 20,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		gap: 12,
	},

	loginContainer: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
	},

	loginContainerCentered: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
	},

	supportContainer: {
		paddingBottom: 15,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		marginTop: 20
	},

	// Typography styles
	titleText: {
		fontWeight: 700,
		fontSize: "clamp(18px, 3vw, 24px)",
		textAlign: "center",
		marginBottom: 10,
		color: "#333333",
	},

	messageText: {
		fontSize: "clamp(16px, 2.2vw, 22px)",
		textAlign: "center",
		color: "#666666",
		lineHeight: 1.4,
		marginBottom: 10,
	},

	verifyPhoneTitle: {
		fontSize: "clamp(18px, 2vw, 22px)",
		fontWeight: 600,
		textAlign: "center",
		marginBottom: 8,
		color: "#333333",
	},

	verifyPhoneSubtitle: {
		fontSize: "clamp(16px, 1.8vw, 20px)",
		textAlign: "center",
		color: "#666666",
		marginBottom: 20,
		lineHeight: 1.4,
	},

	timerText: {
		fontSize: "clamp(14px, 1.8vw, 18px)",
		color: "#999999",
		fontWeight: 500,
		marginBottom: 16,
	},

	connectionErrorText: {
		fontSize: "clamp(14px, 1.8vw, 18px)",
		textAlign: "center",
		color: "#999999",
		fontStyle: "italic",
		marginBottom: 16,
	},

	supportText: {
		fontSize: "clamp(14px, 1vw, 16px)",
		textAlign: "center",
		color: "#666666",
		marginTop: 10,
		textDecoration: "underline",
		width: "90%",
		cursor: "pointer",
	},

	phoneConfirmationText: {
		padding: "0 20px 20px 20px",
		fontSize: 14,
		textAlign: "center",
	},

	// Button styles
	finalizeButton: {
		marginTop: 24,
		maxWidth: "240px",
		width: "100%",
		textTransform: "none",
		fontWeight: "bold",
		backgroundColor: "#672E37",
		color: "#fff",
		border: "none",
		padding: "12px 24px",
		borderRadius: 30,
	},

	finalizeButtonLoading: {
		opacity: 0.5,
	},

	googleButton: {
		fontSize: "clamp(14px, 1vw, 18px)",
		border: "1px solid rgba(0,0,0,0.3)",
		textTransform: "uppercase",
		fontWeight: "Bold",
		marginBottom: "5%",
		backgroundColor: "transparent",
		color: "#222",
	},

	googleButtonLoading: {
		opacity: 0.5,
	},

	phoneButton: {
		fontSize: "clamp(14px, 1vw, 18px)",
		textTransform: "uppercase",
		fontWeight: "Bold",
		backgroundColor: "transparent",
		color: "#222",
		border: "1px solid #222",
	},

	phoneButtonLoading: {
		opacity: 0.5,
	},

	googleIconPosition: {
		position: "absolute",
		left: 16,
	},

	phoneIconPosition: {
		position: "absolute",
		left: 16,
	},

	loadingIcon: {
		color: "#fff",
		marginRight: 8,
	},

	whatsappButtonSpan: {
		flexGrow: 1,
		textAlign: "center",
		marginRight: "24px",
	},

	whatsappButtonIcon: {
		paddingLeft: "2px",
	},

	googleButtonSpan: {
		flexGrow: 1,
		textAlign: "center",
	},

	phoneButtonText: {
		textAlign: "center",
	},

	fallbackButton: {
		fontSize: "clamp(14px, 1vw, 18px)",
		backgroundColor: "#FFFFFF",
		color: "#444",
		border: "1.5px solid rgba(0, 0, 0, 0.15)",
		fontWeight: 600,
		borderRadius: 30,
		padding: "12px 24px",
		cursor: "pointer",
		textTransform: "none"
	}

}));

